import classNames from "classnames";

import {
    BoldIcon,
    H1Icon,
    H2Icon,
    ImageIcon,
    ItalicIcon,
    LinkIcon,
    ListIcon,
    OrderedListIcon,
    UnderlineIcon,
} from "../../assets/icons";

import styles from "./textEditor.module.css";

const Tool = ({ icon, onClick, active }) => {
    return (
        <div
            className={classNames(styles.tool, { [styles.active]: active })}
            onMouseDown={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onClick();
            }}
        >
            {icon}
        </div>
    );
};

export const TextEditorToolbar = ({
    currentBlockType,
    hasInlineStyle,
    hasLinkInSelection,
    onToggleBlockType,
    onToggleInlineStyle,
    onToggleLink,
    onInsertImage,
}) => {
    return (
        <div className={styles.tools}>
            <Tool
                icon={<H1Icon />}
                onClick={() => onToggleBlockType("header-one")}
                active={currentBlockType === "header-one"}
            />

            <Tool
                icon={<H2Icon />}
                onClick={() => onToggleBlockType("header-two")}
                active={currentBlockType === "header-two"}
            />

            <Tool
                icon={<OrderedListIcon />}
                onClick={() => onToggleBlockType("ordered-list-item")}
                active={currentBlockType === "ordered-list-item"}
            />

            <Tool
                icon={<ListIcon />}
                onClick={() => onToggleBlockType("unordered-list-item")}
                active={currentBlockType === "unordered-list-item"}
            />

            <div className={styles.space} />

            <Tool
                icon={<BoldIcon />}
                onClick={() => onToggleInlineStyle("BOLD")}
                active={hasInlineStyle("BOLD")}
            />
            <Tool
                icon={<ItalicIcon />}
                onClick={() => onToggleInlineStyle("ITALIC")}
                active={hasInlineStyle("ITALIC")}
            />
            <Tool
                icon={<UnderlineIcon />}
                onClick={() => onToggleInlineStyle("UNDERLINE")}
                active={hasInlineStyle("UNDERLINE")}
            />

            <div className={styles.space} />

            <Tool
                icon={<LinkIcon />}
                onClick={onToggleLink}
                active={hasLinkInSelection}
            />

            <Tool
                icon={<ImageIcon />}
                onClick={onInsertImage}
            />
        </div>
    );
};
